import { render, staticRenderFns } from "./ReportContact.vue?vue&type=template&id=491b8c4a&scoped=true&"
import script from "./ReportContact.vue?vue&type=script&lang=js&"
export * from "./ReportContact.vue?vue&type=script&lang=js&"
import style0 from "./ReportContact.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ReportContact.vue?vue&type=style&index=1&id=491b8c4a&scoped=true&lang=css&"
import style2 from "./ReportContact.vue?vue&type=style&index=2&id=491b8c4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491b8c4a",
  null
  
)

export default component.exports